import { forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS } from '@angular/forms';

/* eslint-disable @typescript-eslint/no-explicit-any */
export class ValueAccessorProvider {
  static provider(component: any) {
    return {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => component),
      multi: true
    };
  }
}

export class NgValidatorsProvider {
  static provider(component: any) {
    return {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => component),
      multi: true
    };
  }
}
/* eslint-enable @typescript-eslint/no-explicit-any */
